import moment from 'moment.lib';
import { getMomentConfigEn } from './get-moment-config-en';

export const configureMomentForEnglish = () => {
	if (moment.locale() === 'en') {
		moment.updateLocale('en', getMomentConfigEn(moment));
	}
};
